import Choices from 'choices.js'

document.addEventListener('turbo:load', () => {
  const i18n = document.getElementById('choices-i18n')?.dataset || {}

  Object.assign(Choices.defaults.options, {
    removeItemButton: true,
    duplicateItemsAllowed: false,
    searchEnabled: true,
    shouldSort: false,
    placeholder: true,
    searchPlaceholderValue: i18n.searchPlaceholderValue,
    noResultsText: i18n.noResultsText,
    noChoicesText: i18n.noChoicesText,
    loadingText: i18n.loadingText,
    itemSelectText: i18n.itemSelectText,
    uniqueItemText: i18n.uniqueItemText,
    addItemText: (value) => i18n.addItemText?.replace('%{value}', value),
    removeItemIconText: i18n.removeItemIconText,
    removeItemLabelText: (value) => i18n.removeItemLabelText?.replace('%{value}', value),
    maxItemText: (count) => i18n.maxItemText?.replace('%{count}', count)
  })

  document.querySelectorAll('.choices-select').forEach((select) => {
    const maxItemCount = select.dataset.maxItemCount
    new Choices(select, maxItemCount ? { maxItemCount: Number(maxItemCount) } : {})
  })
})
